'use strict';

class ListInput extends BaseComponent {
	static get defaultState() {
		return _.assign(super.constructor.defaultState, {
			sendInputFn: RemoteData.insertNewName,
			nonDeletablePrefixLength: 0,
			minNameLength: 3,
			placeholder: "Name eingeben",
			btn_submit: "Absenden",

			sendEnabled: true
		})
	}

	constructor(element, state) {
		//init BaseComponent
		super(element, state);
		this.debug = false;
		console.log("this.debug", this.debug);
		//set template id
		this._view = $('#atoms_listInput_ListInput').html();

		//set template props
		this._props = {
			placeholder: this.state.placeholder,
			btn_submit: this.state.btn_submit
		};

		this.state.inputString = "";

		_.bindAll(this, 'onClickBtnSend', 'onChangeInput', 'onKeypressInput','sendInput', 'updateEnableBtnSend');

		return this
	}

	init() {
		this.$inInput = $('input', this.$el);
		this.$inBtnSend = $('.btn-send', this.$el);

		this.$inInput.on('keydown', this.onKeypressInput);
		this.$inInput.on('input', this.onChangeInput);
		this.$inBtnSend.on('click', this.onClickBtnSend);

		this.updateEnableBtnSend();
		return this
	}

	onChangeInput(evt) {
		if(this.debug) console.log('ListInput.onChangeInput');

		this.state.inputString = this._internalState.inputString = _.trim(this.$inInput.val());
		this.updateEnableBtnSend();
		return this;
	}

	onKeypressInput(evt) {
		if(this.debug) console.log('ListInput.onKeypressInput', evt.which, this.state.inputString.length);

		evt.stopPropagation();
		//console.log(evt.which);
		switch(evt.which){
			case 8: //backspace
				let str = _.trim(this.$inInput.val());
				if(str.length <= this.state.nonDeletablePrefixLength) evt.preventDefault();
				break;
			case 13: //enter
				evt.preventDefault();
				this.sendInput();
				break;
			case 27: //escape
				break;
		}

		return this;
	};

	onClickBtnSend(evt){
		evt.preventDefault();
		if(this.debug) console.log('ListInput.onClickBtnSend');
		return this.sendInput();
	}

	updateEnableBtnSend(){
		if(this.debug) console.log('ListInput.updateEnableBtnSend');

		if(this.state.inputString.length >= this.state.minNameLength){
			this.$inBtnSend.removeClass('disabled');
		} else {
			this.$inBtnSend.addClass('disabled');
		}
		return this;
	}

	sendInput() {
		if(this.state.inputString.length < this.state.minNameLength || !this.state.sendEnabled){
			return this;
		}

		if(this.debug) console.log('sendInput', this.state.inputString);
		this.state.sendEnabled = false;
		//this.$inBtnSend.addClass('hidden');

		this.state.sendInputFn(this.state.inputString, res => {
			this.$el.trigger(RemoteDataEvent.CREATE, this.state.inputString);
		}, res => {
			console.error(res);
			this.$el.trigger(RemoteDataEvent.ERROR, this.state.inputString);
		});

		return this
	}

	update(force = false) {
		if(!_.isEqual(this._internalState, this.state) || force) {
			this.state.sendEnabled = true;
			this.$inInput.val(this.state.inputString);
			//then copy state
			this._internalState = _.clone(this.state);
		}

		return this;
	}
}
